import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import './SolutionsPage.css';

const solutionsBanner = process.env.PUBLIC_URL + '/images/hero/hero-banner.jpg';

const solutionCategories = [
  {
    id: 1,
    title: 'Modern SAP Solutions for Finance, Operations, and Growth',
    description: 'We help enterprises modernize SAP environments, improve business processes, and build scalable digital foundations.',
    cta: 'Explore SAP Solutions',
    path: ROUTES.SAP_SOLUTIONS,
  },
  {
    id: 2,
    title: 'Data, AI, and Analytics Built for Decision Advantage',
    description: 'We help organizations unify data, activate analytics, and deploy AI responsibly for measurable business value.',
    cta: 'Explore AI Solutions',
    path: ROUTES.AI_SOLUTIONS,
  },
  {
    id: 3,
    title: 'Digital Trust Solutions for the Next Generation Enterprise',
    description: 'We help organizations evaluate and implement blockchain-enabled solutions where transparency, trust, and ecosystem coordination create real value.',
    cta: 'Explore Blockchain Solutions',
    path: ROUTES.BLOCKCHAIN_SOLUTIONS,
  },
];

export default function SolutionsPage() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate(ROUTES.HOME);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleExplore = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleExpertCTA = () => {
    navigate(ROUTES.CONTACT);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="solutions-page">
      {/* Banner Section */}
      <section
        className="solutions-banner inner-page-banner"
        style={{ backgroundImage: `url(${solutionsBanner})` }}
      >
        <div className="solutions-banner-overlay inner-page-banner-overlay" />
        <div className="container solutions-banner-inner inner-page-banner-inner">
          <h1 className="inner-page-banner-title">Solutions</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <button
              type="button"
              className="inner-page-home"
              onClick={handleNavigateHome}
            >
              Home
            </button>
            <span className="inner-page-sep">
              <i className="bi bi-chevron-right" />
            </span>
            <span className="inner-page-current">Solutions</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="solutions-hero-section">
        <div className="container">
          <div className="solutions-hero-content">
            <h1 className="solutions-hero-title">
              Enterprise Solutions Built for Modern Transformation
            </h1>

            <p className="solutions-hero-intro">
              We help organizations modernize core systems, unlock intelligent data platforms, and explore future-ready digital ecosystems through practical, results-driven solutions.
            </p>

            <div className="solutions-hero-buttons">
              <button
                className="btn-primary"
                onClick={() => document.querySelector('.solutions-categories-section').scrollIntoView({ behavior: 'smooth' })}
              >
                Explore Solutions
              </button>
              <button
                className="btn-secondary"
                onClick={handleExpertCTA}
              >
                Talk to an Expert
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Categories Section */}
      <section className="solutions-categories-section">
        <div className="container">
          <div className="solutions-categories-grid">
            {solutionCategories.map((solution) => (
              <div key={solution.id} className="solution-card-wrapper">
                <div className="solution-card">
                  <div className="solution-card-header">
                    <h2 className="solution-card-title">{solution.title}</h2>
                  </div>

                  <p className="solution-card-description">
                    {solution.description}
                  </p>

                  <button
                    className="solution-card-cta"
                    onClick={() => handleExplore(solution.path)}
                  >
                    {solution.cta}
                    <span aria-hidden="true">→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="solutions-cta-section">
        <div className="container">
          <div className="solutions-cta-content">
            <h2 className="solutions-cta-title">
              Ready to start your transformation journey?
            </h2>

            <button
              className="solutions-cta-button"
              onClick={handleExpertCTA}
            >
              Contact Us Today
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
